import React from "react";
import { CellContext } from "@tanstack/react-table";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import DatePicker from "@/Components/ui/DatePicker";
import { dateformat } from "@/utils/GlobalConstants";
import { format } from "date-fns";

export const DateCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue<Date>()
    // We need to keep and update the state of the cell normally
    const [date, setDate] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (date: Date) => {
        setDate(date);
        table.options.meta?.updateData(index, id, date)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setDate(initialValue)
    }, [initialValue])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <div className="text-nowrap text-center">
                <DatePicker key={id + "_RiskDate"} ghost={true}
                    date={date}
                    setDate={(value: Date | ((prevState: Date) => Date)) => {
                        if (value !== undefined && value !== null) {
                            onBlur(value as Date);
                        }
                    }}
                />
            </div>
        );
    }
    return <div className="text-center">{format((date as Date), dateformat)}</div>
};